// src/ConsumerApp/api/invoices/invoice.hooks.js
import { useQuery, useMutation } from '@tanstack/react-query';
import { InvoiceService } from './invoice.service';

export const useGetCustomerInvoices = (customerId) => {
  return useQuery({
    queryKey: ['customerInvoices', customerId],
    queryFn: async () => {
      const response = await InvoiceService.getAllCustomerInvoices(customerId);
      const data = Array.isArray(response) ? response : response?.data || [];
      return data;
    },
    enabled: Boolean(customerId),
    staleTime: 1000 * 60 * 5, // 5 minutes cache
  });
};

export const useDownloadInvoice = () => {
  return useMutation({
    mutationFn: ({ fileRelativePath, invoiceNumber, token }) =>
      InvoiceService.downloadInvoicePdf(fileRelativePath, invoiceNumber, token),
  });
};